export default __webpack_public_path__ + "static/media/mist.1ec62814.svg";